// extracted by mini-css-extract-plugin
module.exports = {"tab":"TopBarTab_tab__2__qM","active":"TopBarTab_active__1kpSr","title":"TopBarTab_title__3BeoO"};